<template>
  <div class="Setdepartment CommonContentSingle-gray">
    <el-container>
      <el-header class="Setdepartment_top" style="
          background: rgba(255, 255, 255, 1);
          height: auto;
        ">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="multipleTable" style="
            margin: 20px 0px;
            background: rgba(255, 255, 255, 1);
            padding: 10px;
            overflow: hidden;
            height: 42px;
          ">
          <el-form-item style="" :label="$t('original.languages601')">
            <el-input v-model="formInline.DeptID" :placeholder="$t('original.languages601')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('original.languages602')">
            <el-input v-model="formInline.DeptName" :placeholder="$t('original.languages602')"></el-input>
          </el-form-item>
          <el-form-item class="cvbb" style="width: 260px">
            <el-button id="focus" @click="screening" @keyup.enter.capture="enterSearch" type="primary">
              {{$t('original.screening')}}
            </el-button>
            <el-button @click="resetForm()">{{$t('original.reset')}}</el-button>
          </el-form-item>
        </el-form>
      </el-header>

      <el-main class="Thelist">
        <div>
          <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
            {{$t('original.languages603')}}
          </el-button>
          <el-button type="primary" @click="dialogVisible = true" plain>
            {{$t('original.languages26')}}
          </el-button>
          <el-button type="primary" @click="exportDepartment" plain>
            {{$t('original.Export_data')}}
          </el-button>
        </div>
        <div class="Thelist_left">
          <h2>{{$t('original.Department_name')}}</h2>

          <!-- <el-tree
          :data="data"
          show-checkbox
          node-key="value"
          default-expand-all
          check-strictly
          @check-change="check_tree"
          ref="treeForm"
        ></el-tree> -->

          <el-tree :data="data" node-key="value" check-strictly :expand-on-click-node="false" @node-click="check_tree"
            @node-expand="check_tree" ref="treeForm"></el-tree>
        </div>
        <div class="Thelist_right">
          <h2>{{$t('original.Name_of_Sub-department')}}</h2>

          <el-table :data="tableData" style="width: 100%" @sort-change="sorting" v-loading="tableLoading"
            :element-loading-text="loadingText">
            <el-table-column :label="$t('original.The_serial_number')" width="60px" align="left">
              <template slot-scope="scope" center>
                {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('original.languages601')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.DeptID }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('original.languages602')">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>{{$t('original.languages602')}}: {{ scope.row.DeptName }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span size="medium">{{ scope.row.DeptName }}</span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages318')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.ContactName }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages604')" min-width="130">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.ContactPhone }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages605')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.totalStudents }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages597')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.noActiveStudents }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages599')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.activeStudents }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages200')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.verifStudents }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages606')">
              <template slot-scope="scope">
                <span style="margin-left: 10px">
                  {{ scope.row.activePercent }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages49')" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
                  {{$t('original.editor')}}
                </el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                  {{$t('original.delete')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-if="tableData.length > 0">
            <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange"
              :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next"
              :total="Counts"></el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- =============新增================ -->
    <el-drawer class="cldrawer" :visible.sync="drawer" :with-header="false" v-loading="drawer_loadings">
      <h2>{{$t('original.languages607')}}</h2>
      <el-form class="el_form" :rules="wrules" ref="form" :model="form" label-width="80px">
        <el-form-item :label="$t('original.languages608')" prop="bumen">


          <div class="block">

            <!-- <el-cascader
              class="last-dept"
              ref="wcascader"
              @change="bumen"
              :options="options"
              :props="{ checkStrictly: true }"
              clearable
            ></el-cascader> -->


            <!-- <el-cascader :ref="wcascader"  :options="options"
              :props="{ multiple: true, value: 'DeptID', label: 'DeptName', children: 'children' }" collapse-tags
              @change="Selected_to_shut_dow" @expand-change="bumen"></el-cascader> -->

            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data"
              :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>


          </div>
        </el-form-item>

        <el-form-item :label="$t('original.languages601')" prop="DeptID">
          <el-input :placeholder="$t('original.languages601')" maxlength="25" v-model="form.DeptID"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.languages602')" prop="DeptName">
          <el-input :placeholder="$t('original.languages602')" maxlength="25" v-model="form.DeptName"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.languages609')">
          <el-input :placeholder="$t('original.languages609')" maxlength="100" show-word-limit type="textarea" v-model="form.DeptAddress"
            class="address-class"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages318')">
          <el-input :placeholder="$t('original.languages318')" maxlength="20" v-model="form.ContactName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages604')">
          <el-input :placeholder="$t('original.languages604')" v-model="form.ContactPhone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="单位口号">
          <el-input
            placeholder="单位口号"
            maxlength="200"
            v-model="form.DeptRecommand"
          ></el-input>
        </el-form-item> -->
        <el-form-item :placeholder="$t('original.languages45')" :label="$t('original.languages45')">
          <el-input v-model="form.LineNumber" maxlength="8"></el-input>
        </el-form-item>
      </el-form>
      <div class="cldrawer_btn">
        <el-button type="success" :loading="iscontinuous" @click="onSubmit">{{$t('original.save')}}</el-button>
        <el-button type="warning" @click="drawer = false">{{$t('original.cancel')}}</el-button>
      </div>
    </el-drawer>
    <!-- =============新增================ -->

    <!-- =============修改================ -->
    <el-drawer class="cldrawer" :visible.sync="drawer2" :with-header="false">
      <h2>{{$t('original.languages610')}}</h2>
      <el-form class="el_form" :rules="rules" ref="form" prop="RoleID" :model="xform" label-width="80px">
        <el-form-item :label="$t('original.languages608')" prop="option">
          <div class="block">
            <el-cascader class="last-dept" ref="wcascaders" @change="Selected_to_shut_dows" @expand-change="bumen"
              v-model="cscsuu" :options="options" :props="{ checkStrictly: true }" clearable
              :placeholder="uxhsxn"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item :label="$t('original.languages601')" prop="DeptID">
          <el-input disabled="disabled" :placeholder="$t('original.languages601')" maxlength="25" v-model="xform.DeptID"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.languages602')" prop="DeptName">
          <el-input :placeholder="$t('original.languages602')" maxlength="25" v-model="xform.DeptName"></el-input>
        </el-form-item>




        <el-form-item :label="$t('original.languages609')">
          <el-input :placeholder="$t('original.languages609')" maxlength="100" show-word-limit type="textarea" v-model="xform.DeptAddress"
            class="address-class"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages318')">
          <el-input :placeholder="$t('original.languages318')" maxlength="25" v-model="xform.ContactName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages604')">
          <el-input :placeholder="$t('original.languages604')" v-model="xform.ContactPhone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="单位口号">
          <el-input
            placeholder="单位口号"
            maxlength="200"
            v-model="xform.DeptRecommand"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item placeholder="排序" label="排序">
          <el-input v-model="xform.LineNumber"></el-input>
        </el-form-item> -->
      </el-form>
      <div class="cldrawer_btn">
        <el-button type="primary" @click="Modify">{{$t('original.languages57')}}</el-button>
        <el-button @click="drawer2 = false">{{$t('original.cancel')}}</el-button>
      </div>
    </el-drawer>
    <!-- =============修改================ -->
    <el-dialog v-loading="loadingsss" :element-loading-text="$t('original.languages611')" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)" :title="$t('original.languages26')" :visible.sync="dialogVisible" width="30%;"
      :before-close="handleClose">
      <div class="down_template" @click="down_template">
        <i class="el-icon-download"></i>
        <span>{{$t('original.languages24')}}</span>
      </div>

      <div class="up_template">
        <el-upload drag ref="upload" :limit="limitNum" :auto-upload="false" accept=".xls,.xlsx" :action="UploadUrl()"
          :on-remove="handleRemove" :before-upload="beforeUploadFile" :on-change="fileChange" :on-success="handleSuccess"
          :on-error="handleError" :file-list="fileList" :on-exceed="exceedFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>{{$t('original.languages29')}}</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            {{$t('original.languages612')}}
          </div>
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('original.cancel')}}</el-button>
        <el-button type="primary" @click="uploadFile">{{$t('original.languages59')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog class="gdds" :title="$t('original.languages614')" :visible.sync="dialogVisible2" width="30%;" style="overflow-y: scroll"
      :before-close="handleClose">
      <el-table :data="tableDatassss" style="width: 100%">
        <el-table-column class="sfsfs" prop="Line" :label="$t('original.languages615')" width="180"></el-table-column>
        <el-table-column prop="Message" :label="$t('original.languages616')" width="180"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      cscsuu: '',
      uxhsxn: '',
      pageIndexs: 1,
      sortingss: '',
      Student_id: '',
      create_time: '',
      Counts: 0, //分页总条数
      loadingsss: false,
      drawer_loadings: false,
      currentPage1: 1,
      dialogVisible: false,
      dialogVisible2: false,
      tableLoading: false,
      loadingText: "正在加载中...",   // 加载提示文字
      types: '1',//查询类型1是搜索2是下拉框
      limitNum: 1,//上传excell时，同时允许上传的最大数
      fileList: [],
      DeptIDs: '',
      DeptNames: '',
      tableDatassss: '',
      form: {
        PDeptID: '',
        DeptID: '',
        DeptName: '',
        DeptAddress: '',
        ContactName: '',
        ContactPhone: '',
        DeptRecommand: '',
        DeptPicture: '',
        LineNumber: '',
      },
      xform: {
        PDeptID: '',
        DeptID: '',
        DeptName: '',
        DeptAddress: '',
        ContactName: '',
        ContactPhone: '',
        DeptRecommand: '',
        DeptPicture: '',
        LineNumber: '',
      },
      options: [],
      option: [],
      data: [],
      tableData: [], //表格数组
      activeName: 'second',
      drawer: false,
      drawer2: false,
      formInline: {
        DeptID: '',
        DeptName: '',
      },
      exportFrom: '',
      arr: [],
      rules: {
        // option: [
        //   { required: true, pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
        // ],
        option: [
          { required: true, message: this.$t('original.languages617'), trigger: 'blur' },
        ],
        DeptID: [
          { required: true, message: this.$t('original.languages618'), trigger: 'blur' },
        ],
        DeptName: [
          { required: true, message: this.$t('original.languages619'), trigger: 'blur' },
        ],
      },
      wrules: {
        bumen: [{ required: true, message: this.$t('original.languages617'), trigger: 'blur' }],
        DeptID: [
          { required: true, message: this.$t('original.languages618'), trigger: 'blur' },
        ],
        DeptName: [
          { required: true, message: this.$t('original.languages619'), trigger: 'blur' },
        ],
      },
    };
  },
  components: {},
  methods: {
    tiaozhuan() {
      // this.$router.push('/Activity/Project')
      // this.$router.push('/Activity/Activity_released')
      // this.$router.push('/Activity/Module_management')
      // this.$router.push('/Activity/Module_circle')
      // this.$router.push('/Activity/Activity_post')
      // this.$router.push('/Psychological/Hours_statistics')
      this.$router.push('/Admin/Working_group');
    },
    sorting({ column, prop, order }) {
      if (prop == 'CreatedDate') {
        this.create_time = order;
        this.sortingss = '';
      } else if (prop == 'LineNumber') {
        this.sortingss = order;
        this.create_time = '';
      }
      if (this.types == 1) {
        this.loading(this.formInline.DeptID, this.formInline.DeptName, this.currentPage1, this.sortingss, this.create_time);
      } else if (this.types == 2) {
        this.loading(this.DeptIDs, this.DeptNames, this.currentPage1, this.sortingss, this.create_time);
      }
      // this.loading('', '', '1',this.sortingss,this.create_time)
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.closeAll();
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
    },
    enterSearch(ea) { },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList.push(file.raw);
    },
    handleRemove() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      //this.fileList=file;
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx' || extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx,xls的文件');
      }
      if (size > 1) {
        this.$message.warning('文件大小不得超过1M');
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success('文件上传成功');
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return '';
    },
    extraData() {
      return {
        name: this.form.name,
        version: this.form.version,
        type: this.form.type,
      };
    },
    uploadFile() {
      //  @click="dialogVisible = false"
      if (this.fileList.length === 0) {
        this.$message.warning('请上传文件');
      } else {
        this.loadingsss = true;
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };
        var fd = new FormData();
        fd.append('file', this.fileList[0]);


        this.$Http_Post('DepartMent/UploadFile', fd).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingsss = false;
            this.$refs.upload.clearFiles();
            this.fileList = [];
            this.Global.request_successful(res.Message);
            this.$Http_Post('DepartMent/GetDeparMent').then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('department', JSON.stringify(res.Data));
                this.data = res.Data;
              } else {
              }
            });
          } else {
            this.loadingsss = false;
            this.Global.request_failure(res.Message);
            this.dialogVisible2 = true;
            this.tableDatassss = res.Data;
            this.$refs.upload.clearFiles();
            this.fileList = [];
          }
        });
      }
    },

    Selected_to_shut_dow(dt) {
      this.form.PDeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
    Selected_to_shut_dows(val) {
      this.xform.PDeptID = val[val.length - 1];
      this.$refs.wcascaders.dropDownVisible = false;
    },
    check_tree(dt, obj, node) {//树点击事件
      if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
        dt.children = [{ label: this.$t('original.languages22') }];
        this.exportFrom.DeptID = dt.DeptID;
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
          DeptID: dt.DeptID,
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data;
            }
          }
        });
      }
      this.arr = [dt.value];
      this.types = '2';
      this.seledeptid = dt.value;
      this.form.pageIndex = '1';
      this.currentPage1 = 1;
      this.DeptIDs = dt.value
      this.DeptNames = dt.label
      this.loading(dt.value, dt.label, '1', this.sortingss, this.create_time);
    },
    handleCurrentChange(val) {
      if (this.types == 1) {
        this.loading(this.formInline.DeptID, this.formInline.DeptName, val, this.sortingss, this.create_time);
      } else if (this.types == 2) {
        this.loading(this.DeptIDs, this.DeptNames, val, this.sortingss, this.create_time);
      }
    },
    handleEdit(index, row) {
      //修改反写
      this.drawer2 = true;
      this.$Http_Post('DepartMent/UpdateDeptMentInfo', { DeptID: row.DeptID, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.cscsuu = res.Data.DeptID;
          this.uxhsxn = res.Data.PDeptName;
          this.option = res.Data.deptids.reverse();
          this.xform.PDeptID = res.Data.PDeptID; //父部门id
          this.xform.DeptID = res.Data.DeptID;
          this.xform.DeptAddress = res.Data.DeptAddress;
          this.xform.ContactName = res.Data.ContactName;
          this.xform.ContactPhone = res.Data.ContactPhone;
          this.xform.DeptRecommand = res.Data.DeptRecommand;
          this.xform.LineNumber = res.Data.LineNumber;
          this.xform.DeptName = res.Data.DeptName;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    vecve() {
      this.$router.push('/consulting/AppointmentList');
    },
    Modify() {//修改按钮
      this.$Http_Post('DepartMent/UpdateDeptMent', this.xform).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          sessionStorage.setItem('department', '');
          this.$Http_Post('DepartMent/GetDeparMent').then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              sessionStorage.setItem('department', JSON.stringify(res.Data));
              this.data = res.Data;
            }
          });
          this.drawer2 = false;
          if (this.types == 1) {
            this.loading(this.formInline.DeptID,this.formInline.DeptName,this.currentPage1,this.sortingss,this.create_time);
          } else if (this.types == 2) {
            this.loading(this.DeptIDs,this.DeptNames,this.currentPage1,this.sortingss,this.create_time);
          }
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    handleDelete(index, row) {//删除
      this.$confirm('数据删除后无法恢复, 是否删除?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showClose: false,closeOnClickModal: false}).then(() => {
        this.$Http_Post('DepartMent/DeleteDeptMent', {DeptID: row.DeptID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            sessionStorage.setItem('department', '');
            this.Global.request_successful(res.Message);
            this.$Http_Post('DepartMent/GetDeparMent').then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.data = res.Data;
                sessionStorage.setItem('department', JSON.stringify(res.Data));
              }
            });
            if (this.types == 1) {
              this.loading(this.formInline.DeptID,this.formInline.DeptName,this.currentPage1,this.sortingss,this.create_time);
            } else if (this.types == 2) {
              this.loading(this.DeptIDs,this.DeptNames,this.currentPage1,this.sortingss,this.create_time);
            }
            this.$Http_Post('DepartMent/GetDeparMent').then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem(
                  'department',
                  JSON.stringify(res.Data)
                );
                this.data = res.Data;
              }
            });
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      })
    },
    down_template() {
      window.location.replace(
        process.env.VUE_APP_URL + 'File/TemplateFile/部门导入.xls'
      );
    },
    onSubmit() {
      //创建
      this.iscontinuous = true
      this.drawer_loadings = true;
      this.$Http_Post('DepartMent/AddDeptMent', this.form).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.iscontinuous = false
          sessionStorage.setItem('department', '');
          this.drawer = false;
          this.Global.request_successful(res.Message);
          this.drawer_loadings = false;
          this.loading('', '', '1', this.sortingss, this.create_time);
          this.$Http_Post('DepartMent/GetDeparMent').then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              sessionStorage.setItem('department', JSON.stringify(res.Data));
              this.options = res.Data;
              this.data = res.Data;
            }
          });
        } else {
          this.iscontinuous = false
          this.drawer_loadings = false;
          this.Global.request_failure(res.Message);
        }
      });
    },
    resetForm(formInline) {
      this.formInline.DeptID = '';
      this.formInline.DeptName = '';
      this.loading('', '', '1', this.sortingss, this.create_time);
    }, //重置
    screening() {
      //筛选this.types = '1';
      this.types = '1';
      this.currentPage1 = 1;
      this.loading(this.formInline.DeptID,this.formInline.DeptName,this.currentPage1,this.sortingss,this.create_time);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => {});
    },
    loading(val, type, numder, sortingss, create_time) {
      this.tableLoading = true;
      this.pageIndexs = numder;
      //表格数据获取接口
      this.exportFrom = {
        DeptID: val,
        DeptName: type,
      };
      this.$Http_Post('DepartMent/GetSubDeptList', {from: this.exportFrom,pageSize: '10',pageIndex: numder,type: this.types,sort: sortingss,datasort: create_time}).then((res) => {
        this.tableLoading = false;
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data.Lists;
          this.Counts = Number(res.Counts);
          var wlists = [];
          for (var i = 0; i < res.Data.Lists.length; i++) {
            wlists.push(res.Data.Lists[i].DeptID);
          }
        } else {
          if (Number(from.pageIndex) > 1) {
            from.pageIndex = from.pageIndex - 1;
            this.currentPage1 = this.currentPage1 - 1;
            this.loading(this.form,this.seledeptid,this.currentPage1,this.sortingss,this.create_time);
          } else {
            this.tableData = res.Data.Lists;
            this.totalnumber = Number(res.Counts);
          }
        }
      });
    },
    exportDepartment: function () {//批量导出部门
      this.$Http_Post('DepartMent/ExportDeptData', {from:this.exportFrom,type:this.types,sort:this.sortingss,datasort:this.create_time}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted() {
    this.loading('', '', '1', this.sortingss, this.create_time);
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '', }).then((res) => {
      if (res.Data) {
        this.data = res.Data;
        this.options = res.Data;
      }
    });
  },
  created() {
    this.enterSearch();
    // this.options = JSON.parse(sessionStorage.getItem('department'));
    // this.data = JSON.parse(sessionStorage.getItem('department'));
  },
};
</script>
<style>
.Setdepartment .Setdepartment_top {
  font-size: 20px;
  border: 1px solid #e3e3e3;
  margin-top: -1px;
  background-color: #fff;
  margin-left: 0px;
}

.Setdepartment button {
  height: 38px;
}

.Setdepartment .Thelist {
  background-color: #fff;
  margin-top: 15px;
}

.Setdepartment .Thelist button {
  height: 36px;
  line-height: 10px;
}

.Setdepartment .Thelist_left {
  width: 300px !important;
  border: 1px solid rgba(225, 226, 227, 1);
  margin-top: 15px;
  float: left;
  height: calc(100% - 52px) !important;
  overflow-y: auto;
}

.Setdepartment .Thelist_right {
  width: calc(100% - 315px) !important;
  border: 1px solid rgba(225, 226, 227, 1);
  float: right;
  margin-top: 15px;
  height: calc(100% - 52px) !important;
  overflow-y: auto;
}

.Setdepartment .Thelist_left h2 {
  padding: 18px;
  font-size: 18px;
}

.Setdepartment .Thelist_right h2 {
  padding: 18px;
  font-size: 18px;
}

.cldrawer {
  height: calc(100% - 40px);
}

.Setdepartment .cldrawer h2 {
  padding: 18px;
  font-size: 18px;
}

.Setdepartment .el_form {
  width: 70%;
  margin-left: 20px;
}

.Setdepartment .cldrawer_btn {
  margin-left: 30%;
  margin-top: 40px;
  margin-bottom: 20px;
}

.Setdepartment .el-dialog {
  width: 41%;
  height: 400px;
}

.Setdepartment .down_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  margin-left: 32%;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.Setdepartment .up_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  margin-left: 32%;
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}

.Setdepartment .el-dialog__footer {
  text-align: center;
  margin-top: 90px !important;
}

.Setdepartment .el-upload-dragger .el-upload__text {
  color: #606266;
  font-size: 14px;
  text-align: center;
  margin-top: -20px;
}

.Setdepartment .el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 9px 0 16px;
  line-height: 50px;
}

.Setdepartment .el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 220px;
  height: 118px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.Setdepartment .el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: -32px;
  width: 220px;
}

.Setdepartment .el-upload-list__item:first-child {
  margin-top: -19px;
}

.Setdepartment .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.Setdepartment .el-dialog {
  width: 41%;
  height: 400px;
}

.Setdepartment .gdds .el-dialog {
  overflow-y: scroll;
}

.Setdepartment .el-table .cell {
  text-align: center;
}

.Setdepartment .el-textarea .el-input__count {
  height: 20px;
  bottom: 12px;
}

.last-dept,
.address-class {
  width: 100%;
}
</style>
